import React, { useState } from 'react';
import PropertyList from '../components/properties/PropertyList.tsx';
import PropertyForm from '../components/properties/PropertyForm.tsx';
import { useProperties } from '../hooks/useProperties.ts';
import { Property } from '../types/property.ts';
import LoadingSpinner from '../components/shared/LoadingSpinner.tsx'
import ErrorMessage from '../components/shared/ErrorMessage.tsx';
import '../styles/Properties.css';
import { propertyService } from '../services/propertyService.ts';


const Properties = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(null);
  const { properties, loading, error, addProperty, updateProperty, deleteProperty } = useProperties();

  const handleAddNew = () => {
    setSelectedProperty(null);
    setIsFormOpen(true);
  };

  const handleEdit = (property: Property) => {
    setSelectedProperty(property);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setSelectedProperty(null);
  };

  const handleDelete = async (id: string) => {
    if (window.confirm('Are you sure you want to delete this property?')) {
      try {
        await deleteProperty(id);
      } catch (error) {
        alert(error.message || 'Failed to delete property');
      }
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} onRetry={propertyService.fetchProperties} />;

  return (
    <div className="properties-page">
      <div className="properties-header tenant-group">
        <h1>Properties</h1>
        <button className="btn-primary" onClick={handleAddNew}>
          Add New Property
        </button>
      </div>

      <PropertyList
        properties={properties}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {isFormOpen && (
        <PropertyForm
          property={selectedProperty}
          onSubmit={async (data) => { await (selectedProperty ? updateProperty(selectedProperty.id, data) : addProperty(data)); }}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default Properties;
